import { PropertyFilterFormModel } from '../../components/property-filter-form/PropertyFilterForm';
import { BuildSerpURLObject } from '../links';
import { PlaceType } from '../../../services/place/place';

export function mapBuildSerpUrlObject(values: PropertyFilterFormModel): BuildSerpURLObject {
  const urlObject: BuildSerpURLObject = {
    size_min: values.size?.min,
    size_max: values.size?.max,
    price_min: values.price?.min,
    price_max: values.price?.max,
  };

  if (values.place) {
    const { type, slug } = values.place;

    if (type === PlaceType.PROVINCE) {
      urlObject.province = slug;
    }

    if (type === PlaceType.LOCALITY) {
      urlObject.locality = slug;
    }

    if (type === PlaceType.AREA) {
      urlObject.area = slug;
      urlObject.locality = values.place.parent?.slug;
    }
  }

  return urlObject;
}
